<template>
  <div>
      Redirecting...

      <form
      method="POST"
      action="https://www.liqpay.ua/api/3/checkout"
      accept-charset="utf-8"
      ref="depositForm"
    >
      <input type="hidden" name="data" :value="form.data" />
      <input type="hidden" name="signature" :value="form.signature" />
    </form>

  </div>
</template>

<script>
import OwnersbotAPI from '@/api/ownersbot'

export default {
    data() {
        return {
            form: {}
        }
    },
    mounted() {
        OwnersbotAPI.getDepositForm(this.$route.params.key).then(data => {
            this.form = data.form;
            this.$nextTick(() => {
                this.$refs.depositForm.submit();
            });
        }).catch(error => {

        });
    }
}
</script>

<style>

</style>